import { create } from 'zustand';

import { createAgentConversationsSlice } from './actions';
import type { AgentConversationsStore } from './types';

export const useAgentConversationsStore = create<AgentConversationsStore>()(
  (set, get, store) => ({
    ...createAgentConversationsSlice(set, get, store),
  }),
);

export {
  selectAttentionConversationIds,
  selectNeedsAttention,
} from './selectors';
export type { AgentConversationsStore, ConversationSlot } from './types';
